<template>
  <popup class="loader-popup" :removeContentPadding="true">
    <template v-slot:content>
      <div class="loader">
        <div v-if="header" class="ri-large-headline margin-top-sm">{{ header }}</div>
        <lottie-player src="/animations/new-brand-loader.json" autoplay loop
                      preserveAspectRatio="xMidYMax slice"/>
        <div class="ri-body margin-top-l margin-bottom-m">{{ context }}</div>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'LoaderPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  props: {
    header: {
      type: String,
      required: false,
    },
    context: {
      type: String,
      default: 'עוד רגע נמשיך...',
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/typography';
@import '~@riseupil/base-ui/src/scss/spacings';

.loader-popup {
  width: 100%;
}

.loader {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  font-family: SimplerPro;

  lottie-player {
    height: 200px;

  }
}
</style>
